module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gender Pay Trap","short_name":"Gender Pay Trap","start_url":"/","background_color":"#FFFFFF","theme_color":"#292A36","display":"standalone","icon":"src/images/favicon/favicon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
